import {
  UserRound,
  Car,
  LifeBuoy,
  ThumbsUp,
  DollarSign,
  Wrench
} from "lucide-react";
import styles from "./WorkM.module.css";

const steps = [
  { icon: <UserRound />, title: "Omówienie potrzeb klienta" },
  { icon: <DollarSign />, title: "Wycena naprwy" },
  { icon: <Car />, title: "Przyjęcie auta na warsztat " },
  { icon: <Wrench />, title: "Właściwa usługa" },
  { icon: <LifeBuoy />, title: "Ewentualne jazda testowa" },
  { icon: <ThumbsUp />, title: "Wydanie pojazdu" }
];
<LifeBuoy />;

export default function Work() {
  return (
    <section className="darkSectionContent" id="work">
      <div className="lightSectionTitle">
        <h1>Etapy naszej pracy</h1>
      </div>
      <div className={styles.flow}>
        {steps.map((s, i) =>
          <div key={i} className={styles.item}>
            <div className={styles.icon}>
              {s.icon}
            </div>
            <p className={styles.workItem}>
              {s.title}
            </p>
            {i < steps.length - 1 && <div className={styles.line} />}
          </div>
        )}
      </div>
    </section>
  );
}
